// extracted by mini-css-extract-plugin
export var infoRow = "_qy-2";
export var labelContainer = "_qy-0";
export var rightInfo = "_qy-1";